<script lang="ts" setup>

</script>

<template>
  <q-card class="iodine-border full-height">
    <h1>Search Pane</h1>
  </q-card>
</template>

<style lang="scss">

</style>
